import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryButtons from './components/CategoryButtons';
import TrustSection from './components/TrustSection';
import ComparisonSection from './components/ComparisonSection';
import SecuritySection from './components/SecuritySection';
import FAQSection from './components/FAQSection';
import ArticlePreviewGrid from './components/ArticlePreviewGrid';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Itaobuy Spreadsheet Italia",
        "url": "https://itaobuyspread.asia",
        "description": "Guida completa italiana a Itaobuy Spreadsheet con prodotti, categorie, QC foto e consigli sicuri.",
        "inLanguage": "it",
        "image": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://itaobuyspread.asia/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }) }} />

      <CategoryButtons />
      <TrustSection />
      <ComparisonSection />

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
            Cosa puoi trovare su Itaobuy Spreadsheet?
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {[
              { icon: 'ri-footprint-line', name: 'Scarpe', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20elegant%20sneakers%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-scarpe-icon&orientation=squarish' },
              { icon: 'ri-t-shirt-line', name: 'Moda', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20clothing%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-moda-icon&orientation=squarish' },
              { icon: 'ri-user-star-line', name: 'Streetwear', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20streetwear%20style%20hoodie%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-streetwear-icon&orientation=squarish' },
              { icon: 'ri-handbag-line', name: 'Accessori', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20accessories%20bag%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-accessori-icon&orientation=squarish' },
              { icon: 'ri-fire-line', name: 'Prodotti virali', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20trending%20popular%20fashion%20items%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-virali-icon&orientation=squarish' },
              { icon: 'ri-bar-chart-line', name: 'Nuovi trend', imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20new%20trend%20fashion%20style%20on%20white%20cream%20background%2C%20clean%20studio%20lighting%2C%20simple%20product%20photography%2C%20warm%20soft%20tones%2C%20no%20text%20no%20people&width=160&height=160&seq=feature-trend-icon&orientation=squarish' },
            ].map((item) => (
              <div key={item.name} className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-background-50">
                  <img src={item.imageUrl} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SecuritySection />
      <ArticlePreviewGrid />

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
            Come iniziare con Itaobuy Spreadsheet
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="text-center p-6">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-4">
                <span className="font-heading text-xl font-bold">1</span>
              </span>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Scegli una categoria</h4>
              <p className="text-sm text-foreground-600">Naviga tra le categorie disponibili dal menu a discesa o dai pulsanti nella homepage.</p>
            </div>
            <div className="text-center p-6">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                <span className="font-heading text-xl font-bold">2</span>
              </span>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Esplora i prodotti</h4>
              <p className="text-sm text-foreground-600">Sfoglia i prodotti disponibili con tutte le informazioni dettagliate di cui hai bisogno.</p>
            </div>
            <div className="text-center p-6">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-500 text-white mx-auto mb-4">
                <span className="font-heading text-xl font-bold">3</span>
              </span>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Acquista in sicurezza</h4>
              <p className="text-sm text-foreground-600">Accedi direttamente ai prodotti che ti interessano con un click e completa il tuo acquisto.</p>
            </div>
          </div>
        </div>
      </section>

      <FAQSection />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Cos'è Itaobuy Spreadsheet?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Itaobuy Spreadsheet è una piattaforma che organizza e cataloga migliaia di prodotti in un formato facile da consultare, permettendo agli utenti di trovare rapidamente ciò che cercano con informazioni dettagliate su prezzi, qualità e recensioni."
            }
          },
          {
            "@type": "Question",
            "name": "Itaobuy Spreadsheet è gratuito?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Le informazioni e le guide presenti su questa piattaforma sono completamente gratuite. Puoi esplorare tutte le categorie e i prodotti senza alcun costo."
            }
          },
          {
            "@type": "Question",
            "name": "Come utilizzare Itaobuy Spreadsheet?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Utilizzare Itaobuy Spreadsheet è semplice: basta selezionare una categoria dal menu a discesa, esplorare i prodotti disponibili e cliccare sui link per accedere direttamente ai prodotti che ti interessano."
            }
          },
          {
            "@type": "Question",
            "name": "Dove trovare i prodotti migliori?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "I prodotti migliori sono organizzati per categoria. Puoi navigare tra scarpe, abbigliamento, accessori e molto altro utilizzando il nostro menu di navigazione o i pulsanti categoria nella homepage."
            }
          },
          {
            "@type": "Question",
            "name": "Itaobuy Spreadsheet è sicuro?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sì, la piattaforma fornisce informazioni trasparenti e verificate. Consigliamo sempre di utilizzare connessioni sicure, verificare le recensioni e proteggere i propri dati personali durante gli acquisti online."
            }
          }
        ]
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://itaobuyspread.asia"
          }
        ]
      }) }} />

      <Footer />
    </main>
  );
}